// Plone theme Barceloneta imports
@import "@plone/plonetheme-barceloneta-base/scss/variables.colors.plone";
@import "@plone/plonetheme-barceloneta-base/scss/variables.colors.dark.plone";
@import "@plone/plonetheme-barceloneta-base/scss/variables.properties";
@import "@plone/plonetheme-barceloneta-base/scss/variables.barceloneta";
@import "@plone/plonetheme-barceloneta-base/scss/base";
@import "@plone/plonetheme-barceloneta-base/scss/root_variables";
@import "@plone/plonetheme-barceloneta-base/scss/toolbar";
@import "@plone/plonetheme-barceloneta-base/scss/icons";

// External libs
@import "../node_modules/swiper/swiper.min.css";
@import "../node_modules/swiper/modules/navigation.min.css";
@import "../node_modules/swiper/modules/pagination.min.css";
@import "@fancyapps/ui/dist/fancybox/fancybox.css";
@import "@fortawesome/fontawesome-free/scss/fontawesome";
@import "@fortawesome/fontawesome-free/scss/brands";
@import "@fortawesome/fontawesome-free/scss/solid";


@import "functions";
@import "variables";
@import "fonts";
@import "common";
@import "navigation";
@import "forms";
@import "table";
@import "tiles";
@import "fixes";
@import "frontpage";
@import "content";